"use client"

import { AnonymousButton, FloppyDiskButton, MediaAttachmentButton, PlaneButton, PreviewPostButton, RoundButton, TimelessPostButton } from "@/components/Atoms/Buttons/ColorButtons"
import { useEffect, useState, useRef } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import Alert from "@/components/Atoms/Alerts/Alert"
// import MentionInput from "@/components/Atoms/MentionTextArea"
import FileUploadDragAndDrop from "@/components/Atoms/FileUploadDragAndDrop"
import { standardizeFileName } from "@/utils/frontend/stringOps"
import { deleteTalnetBrowserCookies } from "@/utils/frontend/cookieOps"
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";
import ActorSelectionDropdown from "@/components/Molecules/ActorSelectionDropdown"
import SocialTopicsAssociationSelect from "@/components/Atoms/Select/SocialTopicsAssociationSelect"
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod"
// import MarkdownEditor from "../MarkdownEditor.js";
import MarkdownEditor from "../../MarkdownEditor"
import InputText from "@/components/Atoms/inputText"
import MentionTextArea from "@/components/Atoms/MentionTextArea"


/*--------------------------------------------------------------------------
  Why are we using generateUUID here? Docs @ x/UUIDS.md
  parentPost is the same as target when target is present
  target is what we use for editing.
--------------------------------------------------------------------------*/
 


const NewSocialPostCard = ({showTopics=true, user, ref, isComment=false, replyToUUID=false, replyToHandle=null, parentPost, replyToUserUUID=null, placeholder, target, presetTopics=null, defaultTextareaValue, anonymousModeButtonDisabled=false, timelessPostButtonDisabled=false, mediaAttachmentButtonDisabled=false, showTopicLevelsTooltip = true, callback = () => {}}, rounded=true) => {


    const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, thisUser, setThisUser, actor, setActor, error, setError, success, setSuccess} = useContext(UIContext);


  // parentPost means this card is actually a comment in a thread

  // const postUUIDRef = useRef(null);

  // if (!postUUIDRef.current) {
  //   postUUIDRef.current = crypto.randomUUID();
  // }

  // const THIS_POST_UUID = postUUIDRef.current;
  // const THIS_POST_UUID = crypto.randomUUID();

  // isNestedComment is a UUID of the comment we're commenting on
  // const CHAR_LIMIT = 1000
  const router = useRouter()
  const searchParams = useSearchParams()
  const params = new URLSearchParams(searchParams.toString())
  let query = null
  //  const blankDataInit = {
  //    id: 0,
  //    social_post_body: '',
  //    social_post_location_country: user?.user_location.country || '',
  //    social_post_location_state: user?.user_location.state || '',
  //    social_post_location_city: user?.user_location.city || '',
  //  }

  // const [thisPostUUID, setThisPostUUID] = useState(crypto.randomUUID())
     
    // get current Primary and Secondary tag associations and set them as default values for 
  let targetAssociatedLevel1Topics = [] // later set as State
  let targetAssociatedLevel2Topics = [] // later set as State
  let targetAssociatedLevel3Topics = [] // later set as State
  let targetAssociatedLevel4Topics = [] // later set as State
  // if (target && target.tags) { 
  //   target.tags.filter(tag => {tag.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : targetAssociatedLevel2Tags.push(tag)})
  // }

  if (target && target.topics) { 
    target.topics.filter(tag => {
      tag.topic_level === 1 ? 
        targetAssociatedLevel1Topics.push(tag) : 
      tag.topic_level === 2 ? 
        targetAssociatedLevel2Topics.push(tag) : 
      tag.topic_level === 3 ? 
      targetAssociatedLevel3Topics.push(tag) : 
        targetAssociatedLevel4Topics.push(tag)
    })
  }


  const socialPostDataInit = {
    parent_social_post_uuid: parentPost ? parentPost.social_post_uuid : '',
    parent_social_post_comment_uuid: replyToUUID ? replyToUUID : '',
    is_anonymous: false,
    is_timeless: false,
    is_commentable: true,
    social_post_body: defaultTextareaValue || '',
    social_post_visibility: 'GLOBAL',
    //   ...(parentPost
    // ? { social_post_comment_uuid: thisPostUUID }
    // : { social_post_uuid: thisPostUUID }
    // ),
    // social_post_body: replyToHandle ? `@${replyToHandle}` : ''
  }

  console.log("TARGET", target)
    const targetDataInit = {
      ...target
  //   id: target?.id,
  //   talent_full_name: target?.talent_full_name,
  //   talent_pseudonym: target?.talent_pseudonym,
  //   talent_job_title_en: target?.talent_job_title.en,
  //   talent_job_title_fr: target?.talent_job_title.fr,
  //   talent_resume_en: target?.talent_resume.en,
  //   talent_resume_fr: target?.talent_resume.fr,
  //   talent_salary: target?.talent_salary,
  //   talent_location_country: target?.talent_location.country || user?.user_location.country,
  //   talent_location_state: target?.talent_location.state || user?.user_location.state,
  //   talent_location_city: target?.talent_location.city || user?.user_location.city,
  //   talent_status: target?.talent_status || "OPEN",
  //   talent_access_level: target?.talent_access_control?.talent_access_level || "STANDARD",
  //   // talent_profile_passwords: target?.talent_access_control?.talent_profile_passwords || {},
  //   talent_profile_passwords:
  // Array.isArray(target?.talent_access_control?.talent_profile_passwords)
  //   ? target.talent_access_control.talent_profile_passwords
  //   : Object.values(target?.talent_access_control?.talent_profile_passwords || []),

  //   talent_is_published: !target ? "PUBLISHED" : target?.talent_is_published === true ? "PUBLISHED" : "UNPUBLISHED" ,
  //   talent_sector_industry: target?.talent_sector_industry
  }

    const blankDataInit = {
    // id: 0,
    // talent_full_name: '',
    // talent_pseudonym: '',
    // talent_job_title_en: '',
    // talent_job_title_fr: '',
    // talent_resume_en: '',
    // talent_resume_fr: '',
    // talent_salary: '',
    // // talent_location: user?.user_location || '',
    // talent_location_country: user?.user_location.country || '',
    // talent_location_state: user?.user_location.state || '',
    // talent_location_city: user?.user_location.city || '',
    // talent_status: "OPEN",
    // talent_access_level: "STANDARD",
    // // talent_profile_passwords: {1: {contact_name: '', contact_password: ''}},
    // talent_profile_passwords: [{"contact_name": "INIT", "contact_password": ""}],
    // talent_is_published: "PUBLISHED" ,
    // talent_sector_industry: ''
        parent_social_post_uuid: parentPost?.social_post_uuid || '',
        parent_social_post_comment_uuid: replyToUUID || '',
  }
     
     
  const [lang, setLang] = useState('en')
  //  const [SMPostData, setSMPostData] = useState(parentPost ? {parent_social_post_uuid: parentPost.social_post_uuid} : '')
  const [SMPostData, setSMPostData] = useState({...socialPostDataInit})
  // console.log("INITIAL SMPostData", SMPostData);
  const [fileData, setFileData] = useState(null)
  // const [success, setSuccess] = useState(false)
  // const [error, setError] = useState(false)
  const [charLimit, setCharLimit] = useState(1000) // social post body
  const [charLimitError, setCharLimitError] = useState(false) // social post body
  const [charCount, setCharCount] = useState(0) // social post body
  const [textAreaRows, setTextAreaRows] = useState(target ? 10 : 1)
  const [fileUploadDialogOpen, setFileUploadDialogOpen] = useState(false)
  const [filePreview, setFilePreview] = useState(null)
  const [topicsTable, setTopicsTable] = useState([])
  const [previewPostOpen, setPreviewPostOpen] = useState(false)
  const [selectedLevel1Topics, setSelectedLevel1Topics] = useState(targetAssociatedLevel1Topics)
  const [selectedLevel2Topics, setSelectedLevel2Topics] = useState(targetAssociatedLevel2Topics)
  const [selectedLevel3Topics, setSelectedLevel3Topics] = useState(targetAssociatedLevel3Topics)
  const [selectedLevel4Topics, setSelectedLevel4Topics] = useState(targetAssociatedLevel4Topics)
  const [currentSocialTopicsLevel, setCurrentSocialTopicsLevel] = useState(1)
  const [topicLevelsTooltipVisible, setTopicLevelsTooltipVisible] = useState(showTopicLevelsTooltip)
  const [isAtPressed, setIsAtPressed] = useState(false)
  const [currentWord, setCurrentWord] = useState(null)
  const [topicsMenuOpen, setTopicsMenuOpen] = useState(false);



  // prevent user from scrolling down in timeless post mode
//   useEffect(() => {
//   if (!SMPostData.is_timeless) return;

//   // Save the existing styles
//   const previousBodyOverflow = document.body.style.overflow;
//   const previousHtmlOverflow = document.documentElement.style.overflow;

//   // Prevent the main page from scrolling
//   document.body.style.overflow = 'hidden';
//   document.documentElement.style.overflow = 'hidden';

//   // Restore the previous styles when exiting timeless mode
//   // or unmounting the component
//   return () => {
//     document.body.style.overflow = previousBodyOverflow;
//     document.documentElement.style.overflow = previousHtmlOverflow;
//   };
// }, [SMPostData.is_timeless]);


// The menu to be openable initially, then stay open after Level 1 is selected until Level 4 is selected.
useEffect(() => {
  if (selectedLevel1Topics.length > 0 && selectedLevel4Topics.length === 0) {
    setTopicsMenuOpen(true);
  }
  if (selectedLevel4Topics.length > 0) {
    setTopicsMenuOpen(false);
  }
}, [selectedLevel1Topics, selectedLevel4Topics]);

    const handleKeyDown = (e) => {
    if (e.key === "@") {
      // Mark that '@' is pressed
      setIsAtPressed(true);
      setCurrentWord(""); // Reset current word when '@' is pressed
    } else if (isAtPressed && /^[a-zA-Z]$/.test(e.key)) {
      // If '@' was pressed and the current key is a letter, add the letter to the current word
      setCurrentWord((prev) => prev + e.key);
    } else if (e.key === " " || e.key === "Enter" || e.key === "Backspace") {
      // When space, enter, or backspace is pressed, reset
      if (isAtPressed && currentWord) {
        console.log(`Word after @: ${currentWord}`);
      }
      setIsAtPressed(false);
      setCurrentWord("");
    }
  };

//  useEffect(() => {
//   console.log(`setting`)
//   setCurrentSocialTopicsLevel(currentSocialTopicsLevel)

// }, [currentSocialTopicsLevel])
  



  // const [actorSelectionDialogOpen, setActorSelectionDialogOpen] = useState(false)
  // const [actor, setActor] = useState(thisUser)
  
  // const [user, setUser] = useState({...getCookies().user})
  const [loading, setLoading] = useState(false)
    
    useEffect(() => {
      // set this user to previous value if there is one, otherwise, to thisUser
      setActor(prev => prev ?? thisUser)
      // const textAreaHeight = document.getElementById('social_post_body')
      // setTextAreaRows(calculateTextAreaHeight(document.getElementById('social_post_body').value))
      // console.log("TEXTAREAHEIGHT", textAreaHeight.value)
      setSMPostData(prev => ({
        ...prev,
        parent_social_post_uuid: parentPost?.social_post_uuid || '',
        parent_social_post_comment_uuid: replyToUUID || '',
        // social_post_body: defaultTextareaValue || ''

        // ...(parentPost
        // ? { social_post_comment_uuid: THIS_POST_UUID }
        // : { social_post_uuid: THIS_POST_UUID }
        // ),
        // social_post_body: replyToHandle ? `@${replyToHandle}` : ''
      }))
    }, [replyToUUID, parentPost, thisUser])




    // get topics
    useEffect(() => {

      if (target) {
        setSMPostData(targetDataInit)
        // set selected primary and secondary tags of a target to what's already associated. This is later updated in callback from handleTagsCallback. 
        setSelectedLevel1Topics(targetAssociatedLevel1Topics)
        setSelectedLevel2Topics(targetAssociatedLevel2Topics)
        setSelectedLevel3Topics(targetAssociatedLevel3Topics)
        setSelectedLevel4Topics(targetAssociatedLevel4Topics)
        // setTalentProfilePasswordKeyValuePairs(Object.keys(targetDataInit.talent_profile_passwords).length)
      }
      else {
        // setSMPostData(blankDataInit)
        setSelectedLevel1Topics([])
        setSelectedLevel2Topics([])
        setSelectedLevel3Topics([])
        setSelectedLevel4Topics([])
      }

      const getTags = async () => {
        try {
          let apiUrl = `/api/social/topics`;
          let response = await fetch(apiUrl, {
            method: `GET`,
            headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
            },
            credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
          });

          response = await response.json();

          setTopicsTable(response.data);
        } catch (error) {
          console.log("error", error);
        }
      };
      getTags()

    }, [target]);


    // set SMPostData.is_timeless from url
// useEffect(() => {
//   setSMPostData(prev => ({
//     ...prev,
//     is_timeless: searchParams.get('switchToTimeless') === 'true'
//   }))
// }, [searchParams])

    




// const handleTopicSelectCallback = ({ allTags }) => {
//   const tags = allTags ?? []

//   if (tags.some(t => t.topic_name_en?.toUpperCase() === 'TALNET') &&
//       user?.user_roles?.role !== 'ROOT') {
//     setError({ message: 'Talnet is a reserved topic' })
//     return
//   }

//   const byLevel = n => tags.filter(t => t.topic_level === n)

//   const l1 = byLevel(1).slice(0, 1)
//   const l1Uuids = l1.map(t => t.uuid)
//   const l2 = byLevel(2).slice(0, 1).filter(t => l1Uuids.includes(t.parent_topic_uuid))
//   const l3 = byLevel(3).slice(0, 1)
//   const l4 = byLevel(4)

//   setSelectedLevel1Topics(l1)
//   setSelectedLevel2Topics(l2)
//   setSelectedLevel3Topics(l3)
//   setSelectedLevel4Topics(l4)

//   // first empty level wins
//   const l1HasChildren = topicsTable?.some(
//     t => t.topic_level === 2 && l1Uuids.includes(t.parent_topic_uuid)
//   )
//   setCurrentSocialTopicsLevel(
//     l1.length === 0 ? 1 :
//     (l1HasChildren && l2.length === 0) ? 2 :
//     l3.length === 0 ? 3 :
//     4
//   )
// }


const sortTopicsArrByLevel = ({level1Topics, level2Topics, level3Topics, level4Topics}) => {
      let concatenatedTopicsArr =
      (level1Topics || [])
        .concat(level2Topics || [])
        .concat(level3Topics || [])
        .concat(level4Topics || [])


    // swap the child's trimmed option objects for the full records (restores parent_topic_uuid)
    concatenatedTopicsArr = concatenatedTopicsArr.map(chip => {
      const full = topicsTable?.find(t => t.uuid === chip.uuid)
      return full ? { ...chip, ...full } : chip
    })

    const byLevel = n => concatenatedTopicsArr.filter(t => t.topic_level === n)

    const l1 = byLevel(1).slice(0, 1)
    const l1Uuids = l1.map(t => t.uuid)
    const l2 = byLevel(2).slice(0, 2).filter(t => l1Uuids.includes(t.parent_topic_uuid)) // allow 2 level2 topics
    const l3 = byLevel(3).slice(0, 1)
    const l4 = byLevel(4)

    setSelectedLevel1Topics(l1)
    setSelectedLevel2Topics(l2)
    setSelectedLevel3Topics(l3)
    setSelectedLevel4Topics(l4)

    // first empty level wins
    const l1HasChildren = topicsTable?.some(
      t => t.topic_level === 2 && l1Uuids.includes(t.parent_topic_uuid)
    )
    // setCurrentSocialTopicsLevel(
    //   l1.length === 0 ? 1 :
    //   (l1HasChildren && l2.length === 0) ? 2 :
    //   l3.length === 0 ? 3 :
    //   4)
    
      setCurrentSocialTopicsLevel(
  l1.length === 0 ? 1 :
  (l1HasChildren && (l2.length === 0 || l2.length === 1)) ? 2 :// allow second level2 topic
  l3.length === 0 ? 3 :
  4
)
}


useEffect(() => {
      // v2 - claude
      sortTopicsArrByLevel({level1Topics:targetAssociatedLevel1Topics, level2Topics: targetAssociatedLevel2Topics, level3Topics: targetAssociatedLevel3Topics, level4Topics: targetAssociatedLevel4Topics})
      // refactored onto above function
    // let concatenatedTopicsArr =
    //   (targetAssociatedLevel1Topics || [])
    //     .concat(targetAssociatedLevel2Topics || [])
    //     .concat(targetAssociatedLevel3Topics || [])
    //     .concat(targetAssociatedLevel4Topics || [])


    // // swap the child's trimmed option objects for the full records (restores parent_topic_uuid)
    // concatenatedTopicsArr = concatenatedTopicsArr.map(chip => {
    //   const full = topicsTable?.find(t => t.uuid === chip.uuid)
    //   return full ? { ...chip, ...full } : chip
    // })

    // const byLevel = n => concatenatedTopicsArr.filter(t => t.topic_level === n)

    // const l1 = byLevel(1).slice(0, 1)
    // const l1Uuids = l1.map(t => t.uuid)
    // const l2 = byLevel(2).slice(0, 1).filter(t => l1Uuids.includes(t.parent_topic_uuid))
    // const l3 = byLevel(3).slice(0, 1)
    // const l4 = byLevel(4)

    // setSelectedLevel1Topics(l1)
    // setSelectedLevel2Topics(l2)
    // setSelectedLevel3Topics(l3)
    // setSelectedLevel4Topics(l4)

    // // first empty level wins
    // const l1HasChildren = topicsTable?.some(
    //   t => t.topic_level === 2 && l1Uuids.includes(t.parent_topic_uuid)
    // )
    // setCurrentSocialTopicsLevel(
    //   l1.length === 0 ? 1 :
    //   (l1HasChildren && l2.length === 0) ? 2 :
    //   l3.length === 0 ? 3 :
    //   4)
}, [target])

// v1
    const handleTopicSelectCallback = cb => {
    /*============================================
    | **What area is this post in?**                     | Required. One choice.                                      |
    | -------------------------------------------------- | ---------------------------------------------------------- |
    | **Where within that area?**                        | Conditional. Shown only if the L1 choice has children.     |
    | **What is it about?** (the focus)                  | Optional. Ideally multi-select.                            |
    | **What kind of post is it?** (the author's intent) | Required. One choice, and the easiest for users to answer. |
    ============================================*/

    console.log('Callback@HandleTopicSelectCallback', cb)
    
    // when editing post is initializing, the topic level tool tip (angle, intent, etc) is not visible. Upon change in the socialTopicsAssociationSelect, the tooltip becomes visible
    if (cb) {
      setTopicLevelsTooltipVisible(true)
    }
    
    // prevent users form posting to #Talnet topic
    // const topicIsTalnet =
    //   cb?.lvlOne?.newTags?.some(topic => topic.topic_name_en?.toUpperCase() === 'TALNET') ||
    //   cb?.lvlTwo?.newTags?.some(topic => topic.topic_name_en?.toUpperCase() === 'TALNET') ||
    //   cb?.lvlThree?.newTags?.some(topic => topic.topic_name_en?.toUpperCase() === 'TALNET') ||
    //   cb?.lvlFour?.newTags?.some(topic => topic.topic_name_en?.toUpperCase() === 'TALNET') ||
    //   false
    // if (topicIsTalnet && user?.user_roles?.role !== 'ROOT') {
    //   setError({message: 'Talnet is a reserved topic'})
    //   return;
    // }
    const reservedTopics = ['TALNET', 'CHANGELOG'];

const topicIsReserved = [
  ...(cb?.lvlOne?.newTags || []),
  ...(cb?.lvlTwo?.newTags || []),
  ...(cb?.lvlThree?.newTags || []),
  ...(cb?.lvlFour?.newTags || [])
].some(topic =>
  reservedTopics.includes(topic.topic_name_en?.toUpperCase())
);

if (topicIsReserved && user?.user_roles?.role !== 'ROOT') {
  setError({ message: 'This is a reserved topic' });
  return;
}


    // v2 - claude
    sortTopicsArrByLevel({level1Topics:cb?.lvlOne?.newTags, level2Topics:cb?.lvlTwo?.newTags, level3Topics:cb?.lvlThree?.newTags, level4Topics:cb?.lvlFour?.newTags})
    // refactored onto the above function
    // let concatenatedTopicsArr =
    //   (cb?.lvlOne?.newTags || [])
    //     .concat(cb?.lvlTwo?.newTags || [])
    //     .concat(cb?.lvlThree?.newTags || [])
    //     .concat(cb?.lvlFour?.newTags || [])


    // // swap the child's trimmed option objects for the full records (restores parent_topic_uuid)
    // concatenatedTopicsArr = concatenatedTopicsArr.map(chip => {
    //   const full = topicsTable?.find(t => t.uuid === chip.uuid)
    //   return full ? { ...chip, ...full } : chip
    // })

    // const byLevel = n => concatenatedTopicsArr.filter(t => t.topic_level === n)

    // const l1 = byLevel(1).slice(0, 1)
    // const l1Uuids = l1.map(t => t.uuid)
    // const l2 = byLevel(2).slice(0, 1).filter(t => l1Uuids.includes(t.parent_topic_uuid))
    // const l3 = byLevel(3).slice(0, 1)
    // const l4 = byLevel(4)

    // setSelectedLevel1Topics(l1)
    // setSelectedLevel2Topics(l2)
    // setSelectedLevel3Topics(l3)
    // setSelectedLevel4Topics(l4)

    // // first empty level wins
    // const l1HasChildren = topicsTable?.some(
    //   t => t.topic_level === 2 && l1Uuids.includes(t.parent_topic_uuid)
    // )
    // setCurrentSocialTopicsLevel(
    //   l1.length === 0 ? 1 :
    //   (l1HasChildren && l2.length === 0) ? 2 :
    //   l3.length === 0 ? 3 :
    //   4
    // )





    // v2 end

    // v1 start
    // if (cb.lvlOne) {  // lvl1
    //   setSelectedLevel1Topics(cb.lvlOne.newTags)
    //   cb.lvlOne.newTags?.length > 0 ? setCurrentSocialTopicsLevel(2) : setCurrentSocialTopicsLevel(1) 
    // }
    // if (cb.lvlTwo) { // lvl2
    //   setSelectedLevel2Topics(cb.lvlTwo.newTags)
    //   cb.lvlTwo.newTags?.length > 0 ? setCurrentSocialTopicsLevel(3) : setCurrentSocialTopicsLevel(1)
    // }
    // if (cb.lvlThree) { // lvl3
    //   setSelectedLevel3Topics(cb.lvlThree.newTags)
    //   cb.lvlThree.newTags?.length > 0 ? setCurrentSocialTopicsLevel(4) : setCurrentSocialTopicsLevel(2)
    // }
    // if (cb.lvlFour) { // lvl4
    //   setSelectedLevel4Topics(cb.lvlFour.newTags)
    // }
    // v1 end
  }

    const calculateTextAreaRows = (str = "", isTimeless) => {

      const MIN_ROWS = isTimeless ? 25 : 2
      const MAX_ROWS = 15
      // const MAX_ROWS = parentPost ? 5 : isTimeless ? 25 : 10 // if in thread (replying to post or comment), cap at 5. If new post, cap at 10. If new post is timeless, cap at 20.
      // Empty → reset
      if (str.length === 0) {
        setTextAreaRows(MIN_ROWS)
        return
      }

      const newLines = str.split("\n").length
      const lengthRows = Math.ceil(str.length / 100)

      const rows = Math.min(
        MAX_ROWS,
        Math.max(MIN_ROWS, Math.max(newLines, lengthRows))
      )

      setTextAreaRows(rows)
    }

    const handleChange = (event) => {

      // console.log("EVENT", event.target?.name, event.target?.value)
        if (event.target?.type === "checkbox") { // used by is_commentable
          setSMPostData((prev) => ({
            ...prev,
              [event.target?.name]: !prev[event.target?.name],
          }));
          console.log("SMPOSTDATA - is commentable", SMPostData.is_commentable)
          return;
        }

        // if (event.target?.type === "radio") { // used by social_post_visibility
        //   setSMPostData((prev) => ({
        //     ...prev,
        //       [event.target?.name]: !prev[event.target?.name],
        //   }));
        //   console.log("SMPOSTDATA - is commentable", SMPostData.is_commentable)
        //   return;
        // }
      // console.log(event.target.value.split("\n").length)
      // Ensure input is under char limit
      setCharCount(event.target.value?.length) // -replyToHandle.length
      if (event.target.value?.length >= charLimit) { // +replyToHandle.length
        setCharLimitError({message: 'Character limit exceeded'})
      }
      else {setCharLimitError(false)}

      calculateTextAreaRows(event.target.value, SMPostData.is_timeless)
    


    // if (event.target?.name ==='job_salary') {
    //   setSMData((prevData) => ({
    //     ...prevData,
    //     [event.target?.name]: event.target.value.replace(/\D/g, '')
    //   }));
    //   return;
    // }

    setSMPostData((prevData) => ({
      ...prevData,
      [event.target?.name]: event.target?.value,
    }));
  
    // if(event.target?.value.length > 1){setMissingFields((prevMissingFields) => ({
    //   ...prevMissingFields,
    //   [event.target?.name]: false, // Mark the field as not missing
    // }));}
  };


  const handleSubmit = async (status = 'ACTIVE') => {

    setLoading(true);

    // 1. Generate UUID for THIS submission
    const postUUID = crypto.randomUUID();

    // 2. Build the payload ONCE (source of truth)
    let postPayload;
    if (target){ // if editing
      postPayload = {
          ...SMPostData, // build as is, as social_post_body and title are being changed anyway in this obj
          status: status
      };
    } else { // if new post or comment or reply
        postPayload = {
          ...SMPostData,
          ...(parentPost
            ? { social_post_comment_uuid: postUUID }
            : { social_post_uuid: postUUID }
          ),
          status: status
      };
    }
  console.log("PAYLOAD", postPayload)
    // ----------------------------
    // Validation
    // ----------------------------
    const body = postPayload.social_post_body?.trim();
    if (!body) {
      setError({ message: 'No text entered' });
      setLoading(false);
      return;
    }

    if (SMPostData.is_timeless === true){
        const postTitle = postPayload.social_post_title?.trim();
      if (!postTitle) {
      setError({ message: 'Timeless posts must have a title' });
        setLoading(false);
        return;
      }
      else if (postTitle.length > 80) {
        setError({message: 'Title over 80 characters'})
        setLoading(false)
        return;
      }
    }
    
    // ----------------------------
    // File upload (uses SAME UUID)
    // ----------------------------
    if (fileData?.file) {
      const formData = new FormData();
      formData.append("file", fileData.file, fileData.file_name);
      formData.append("file_name", fileData.file_name);
      formData.append("file_extension", fileData.file_extension);
      formData.append("user", JSON.stringify(user));

      let mediaUploadResponse = await fetch(
        `/api/services/files?user_type=${user.user_type}&file_type=MEDIA&parent_record_uuid=${postUUID}&record_type=SOCIAL`,
        {
          method: "POST",
          credentials: "include",
          body: formData,
        }
      );

      console.log(mediaUploadResponse.status)


      if (mediaUploadResponse.status !== 200) {

        mediaUploadResponse.status === 401 && deleteTalnetBrowserCookies()

        console.log('ERROR: ', mediaUploadResponse)
        mediaUploadResponse = await mediaUploadResponse.json()
        setError({message: `Couldn't upload file. Error: ${mediaUploadResponse.error.message || mediaUploadResponse.error  }`})
        setLoading(false);
        return;
      }
    }

    // ----------------------------
    // Create post / comment
    // ----------------------------
    try {
      let apiUrl = target ? `/api/social/posts/${target.social_post_uuid}?user_type=${user.user_type}` : `/api/social/posts/?user_type=${user.user_type}`
      console.log("PARENT_POST:", parentPost)
      const response = await fetch(
        apiUrl,
        // `/api/social/posts/?user_type=${user.user_type}`,
        {
          method: target ? "PUT" : "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            record_data: parentPost,
            data: postPayload, // ✅ NOT state
            notification_recipient_user_uuid: parentPost
              ? parentPost.social_post_user_uuid
              : null,
            topics:{
              LEVEL_1: selectedLevel1Topics,
  //             LEVEL_1: Object.values( // remove duplicates
  //   [...(selectedLevel1Topics ?? []), ...(presetTopics ?? [])]
  //     .reduce((acc, topic) => {
  //       acc[topic.id] = topic;
  //       return acc;
  //     }, {})
  // ),
              LEVEL_2: selectedLevel2Topics, 
              LEVEL_3: selectedLevel3Topics,
              LEVEL_4: selectedLevel4Topics
            },
            user,
            actor
          }),
        }
      );

      
      if (response.status === 401) { deleteTalnetBrowserCookies() }
      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message);
      }

      // ----------------------------
      // UI cleanup
      // ----------------------------
      let successMessage;
      if (SMPostData.is_timeless) {
        successMessage = "Your timeless post has been submitted for verification"
      }
      else if (status === 'DRAFT') {
        successMessage = "Draft saved"
      }
      else {
        successMessage = "Post / comment published."
      }
      setSuccess({ message: successMessage });
      setSMPostData(prev => ({ ...prev, social_post_body: "", is_timeless: false }));
      setFileData(null)
      setFileUploadDialogOpen(false)
      setSelectedLevel1Topics([])
      setCurrentSocialTopicsLevel(1)
      setFilePreview(null)
      setTextAreaRows(1)
      callback({editing:false})
        params.delete('editing'); // for the sake of completeness, post edit does not depend on this. We only use ?editing=true as a flag when hitting edit button from main social feed
      router.push(`?${params.toString()}`) // for the sake of completeness, post edit does not depend on this. We only use ?editing=true as a flag when hitting edit button from main social feed

      router.refresh();

    } catch (err) {
      setError({ message: err.message || "Failed to publish" });
    } finally {
      setLoading(false);
    }
  };







  //v1 
  // const handleSubmit = async () => {

  //       // Generate a fresh UUID for this submission
  //     const thisPostUUID = crypto.randomUUID();

  //     // Update both state and the post data object
  //     setSMPostData(prev => ({
  //       ...prev,
  //       ...(parentPost
  //         ? { social_post_comment_uuid: thisPostUUID }
  //         : { social_post_uuid: thisPostUUID }
  //       ),
  //     }));

  //     /*----------------------------
  //       File upload logic
  //     ----------------------------*/
  //   if (fileData && fileData.file) {
  //     const formData = new FormData()
  //           console.log("SUBMITFILE", fileData)

  //     formData.append("file", fileData.file, fileData.file_name);
  //     formData.append("file_name", fileData.file_name),
  //     formData.append("file_extension", fileData.file_extension)

  //     formData.append("user", JSON.stringify(user))                             /* LOOK HERE, UUID 🛎️ */
  //     let apiUrl = `/api/services/files?user_type=${user.user_type}&file_type=MEDIA&record_uuid=${thisPostUUID}&record_type=SOCIAL`;
  //     let response = await fetch(apiUrl, {
  //       method: 'POST',
  //       credentials: 'include', // Keep this if you need cookies sent
  //       body: formData, // Send formData object
  //     });
  //     console.log("APIURL-FILES", apiUrl)
  //   let responseJSON = await response.json();
  //   console.log("Response: ", responseJSON)
  //   }


  //     console.log("SUBMITDATA", SMPostData)
  //     console.log("PARENTPOST", parentPost)
  //     setLoading(true)
  //     if (charLimitError) {
  //       setError({message: 'Character count exceeded'})
  //       setLoading(false)
  //       return;
  //     }


  //     const body = SMPostData.social_post_body?.trim();

  //     if (!body) {
  //       setError({ message: 'No text entered' });
  //       setLoading(false);
  //       return;
  //     }


  //     let target=null;
    
  //       try {
  //         console.log("SMPOSTDATA", SMPostData)
  //         // if (isNestedComment) {

  //         // }
  //         let apiUrl = target ? `/social/posts/?id=${target.id}&user_type=${user.user_type}` : `/api/social/posts/?user_type=${user.user_type}`
  //         let response = await fetch(apiUrl, {
  //         method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
  //         headers: {
  //           'Accept': '*/*',
  //           'Content-Type': 'application/json'
  //         },
  //         credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
  //         body: JSON.stringify({
  //           data: SMPostData, 
  //           notification_recipient_user_uuid: parentPost ?  parentPost.social_post_actor_uuid : null,  
  //           // notification_recipient_user_uuid: parentPost.social_post_actor_uuid,
  //           user: user
  //           // tags: {LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags, LEVEL_3: selectedLevel3Tags}, 

  //         }), // Convert the credentials object to a JSON string
  //         // body: data
  //       });

  //       response = await response.json()
  //       console.log('handleSubmitResponse', response)
  
  //     if (response.success === true ) {
  //       setSuccess({message: 'Post / comment has been published.'})
  //       // callback({refreshData: true})
  //       // callback({resetTarget: true})
  //       setLoading(false)
  //       setSMPostData({...SMPostData, social_post_body: ''})
  //       router.refresh()
  //     }
  //     else { 
  //       setError({message: `Could not publish the post / comment. Error: ${response.message}`})
  //       setLoading(false)
  //     }
  //     // callback({refreshData: true})

            
  //       } catch (error) {
  //         console.log('error', error)
  //           setError({message: `Could not publish the post / comment. Error: ${error}`})
  //         setLoading(false)
  //       }
  // };

  const handleFileUpload = (cb) => {

    if (cb.action === 'fileUpload') {
      setFileData({...fileData, file_name: standardizeFileName(cb.file.name), file_extension: cb.file.name.split('.')[1], file: cb.file})
      setFilePreview(URL.createObjectURL(cb.file))
    }

    if (cb === 'closeDialog' || cb === 'isDropped') {
      setFileUploadDialogOpen(false)
    }
  }


  const textAreaRef1 = useRef(null) // used for timeless post markdown



  return (
     <>
      <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>

    {/* {!parentPost && <div className="z-50">
    <SocialTopicsAssociationSelect isMulti={true} tagsTable={topicsTable} callback={handleTagsCallback} tagsLevel={1} target={target} placeholder={'Topics'} selectedParent={'data.talent_sector_industry?.id'}/>
    </div>} */}

<div className={parentPost && 'mt-1 mb-1' }>

{/* <div className=" relative
    mx-auto
    w-full
    max-w-7xl
    px-4
    py-14
overflow-x-hidden
    z-10"> */}

     <div className={`${SMPostData.is_timeless ? `mt-2 transition-all duration-150 relative left-1/2 -translate-x-1/2 xl:w-[calc(100vw-40rem)] ${parentPost ? 'max-w-7xl mt-2' : ''} bg-slate-200 dark:bg-slate-700 py-14 rounded-2xl` : ''} relative z-10`}>
    {/* <div className={`${SMPostData.is_timeless && `fixed inset-0 transition-all duration-150 left-1/2 -translate-x-1/2 xl:w-[calc(100vw-2rem)] ${parentPost ? 'max-w-7xl mt-2' : 'max-w-8xl'} bg-slate-200 dark:bg-slate-700 py-14 rounded-2xl`} relative z-10`}> */}
 

      {/* <TextAreaAutoGrow
        value={SMPostData.social_post_body}
        onChange={handleChange}
        /> */}



  { fileUploadDialogOpen ? 

    <FileUploadDragAndDrop
      paddingY={SMPostData.is_timeless ===true ? 'sm' : 'lg'}
      marginY={SMPostData.is_timeless === true ? '' : 'mb-2'}
      marginX={SMPostData.is_timeless === true ? 'mx-4' : ''}
      caption={'Drag and drop an image here or click to browse'}
      callback={cb => handleFileUpload(cb)}
      lang={'en'}
      // fileName={'testFileName'}
      fileName={fileData?.file_name}
    />

    // <div className={`${SMPostData.is_timeless && 'transition-all duration-150 relative left-1/2 -translate-x-1/2 w-[calc(100vw-6rem)] w-full md:max-w-5xl'}`}>
      : 
    <div className={`${SMPostData.is_timeless && `absolute px-4 transition-all duration-150 relative left-1/2 -translate-x-1/2 xl:w-[calc(100vw-40rem)]  ${parentPost ? 'max-w-7xl' : 'max-w-8xl'}`}`}>
  {/* was 100vw-6rem */}

  {/* topic descriptions */}
  {SMPostData.is_timeless === true && <div>
      {selectedLevel1Topics?.length > 0 && 
      selectedLevel1Topics.map(topic => topic.topic_description?.en &&
      <div key={topic.uuid}
      className={`px-4 ${SMPostData.is_timeless === true && ""} py-2 ${'mt-2'}
  rounded-lg
  border border-teal-200 dark:border-teal-500
  bg-teal-50
  dark:bg-transparent
  text-teal-800`}>
        <p className="text-xs"><strong>{topic.topic_name_en} topic subjects:</strong> {topic.topic_description?.en?.split('\n').join(', ')}</p>
      </div>)}

          {selectedLevel2Topics?.length > 0 && 
      selectedLevel2Topics.map(topic => topic.topic_description?.en &&
      <div key={topic.uuid}
      className={`px-4 ${SMPostData.is_timeless === true && ""} py-2 ${'mt-2'}
  rounded-lg
  border border-teal-200 dark:border-teal-500
  bg-teal-50
  dark:bg-transparent
  text-teal-800`}>
        <p className="text-xs"><strong>{topic.topic_name_en} topic subjects:</strong> {topic.topic_description?.en?.split('\n').join(', ')}</p>
      </div>)}

            {selectedLevel3Topics?.length > 0 && 
      selectedLevel3Topics.map(topic => topic.topic_description?.en &&
      <div key={topic.uuid}
      className={`px-4 ${SMPostData.is_timeless === true && ""} py-2 ${'mt-2'}
  rounded-lg
  border border-teal-200 dark:border-teal-500
  bg-teal-50
  dark:bg-transparent
  text-teal-800`}>
        <p className="text-xs"><strong>{topic.topic_name_en} topic subjects:</strong> {topic.topic_description?.en?.split('\n').join(', ')}</p>
      </div>)}

            {selectedLevel4Topics?.length > 0 && 
      selectedLevel4Topics.map(topic => topic.topic_description?.en &&
      <div key={topic.uuid}
      className={`px-4 ${SMPostData.is_timeless === true && ""} py-2 ${'mt-2'}
  rounded-lg
  border border-teal-200 dark:border-teal-500
  bg-teal-50
  dark:bg-transparent
  text-teal-800`}>
        <p className="text-xs"><strong>{topic.topic_name_en} topic subjects:</strong> {topic.topic_description?.en?.split('\n').join(', ')}</p>
      </div>)}
  </div>}



  {/* reddit */}
  { SMPostData.is_timeless ? 

    <div className="mt-4 flex flex-col gap-2">
      
      <div className="grid lg:grid-cols-2 gap-2">


            <div className="w-full">
               <p className="mx-1 my-1 text-slate-400 text-sm">
              Give your post a descriptive title
             </p>
             <div className="dark:border dark:rounded-lg dark:border-slate-600">
              <InputText 
              name='social_post_title'
              required={false}
              lightBGValue={'bg-slate-100 dark:bg-slate-700'}
              darkBGValue={'dark:bg-slate-700'}
              data={{
                type: 'text',
                id: 'social_post_title',
                onChange:(x)=>{handleChange(x)},
                label: 'Post Title',
                value: SMPostData?.social_post_title || ''
                }}
                // error={missingFields?.social_post_title ? true : false}
                />
                </div>
            </div>
                
            {/* topic selection */}
            <div className="w-full">

                {topicLevelsTooltipVisible === true && 
              <div className="mx-1 my-1 text-slate-400 text-sm flex justify-between items-center gap-8">
                {/* {currentSocialTopicsLevel > 1 ? 
                  <RoundButton 
                    caption={
                      currentSocialTopicsLevel === 2 ? 'Area' :
                      currentSocialTopicsLevel === 3 ? 'Stage' :
                      currentSocialTopicsLevel === 4 ? 'Focus' : 
                      ''
                    } 
                    onClick={()=>setCurrentSocialTopicsLevel(prev => prev - 1)}
                  /> 
                  : <div></div>
                } */}
                <div className="">
                <label className="">
                {currentSocialTopicsLevel === 1  ? 
                  <>What <strong>area</strong> is this post in? (select 1)</> : 
                currentSocialTopicsLevel === 2  ?
                  <>Where <strong>within {selectedLevel1Topics?.[0]?.topic_name_en}</strong>? (<strong>the stage</strong>, select up to 2, or <span className="underline cursor-pointer" onClick={()=>setCurrentSocialTopicsLevel(3)}>skip the second</span>)</> :
                currentSocialTopicsLevel === 3  ? 
                  <>What is it about? (<strong>the focus</strong>, select 1, or <span className="underline cursor-pointer" onClick={()=>setCurrentSocialTopicsLevel(4)}>skip the focus topic</span>)</> : 
                currentSocialTopicsLevel === 4  ? 
                  <>What kind of post is it? (<strong>the intent</strong>, select 1)</>
                  : currentSocialTopicsLevel + ' ' + 'Done!'
                  }
              </label>
              </div>
              {/* {currentSocialTopicsLevel < 4 ? <RoundButton 
                onClick={()=>setCurrentSocialTopicsLevel(prev => prev + 1)} 
                caption={
                  currentSocialTopicsLevel === 1 ? 'Stage' :
                    currentSocialTopicsLevel === 2 ? 'Focus' :
                    currentSocialTopicsLevel === 3 ? 'Intent' : 
                    ''
                } 
                iconClassName={'fa-solid fa-arrow-right-long'} 
                order={'iconAfterCaption'}
              />
                :
                <div></div>
              } */}
              </div>}

                {(!parentPost || target) && showTopics===true && 
                <div className={` dark:border dark:rounded-lg dark:border-slate-600 ${SMPostData.is_timeless && ''}`}>
                  <SocialTopicsAssociationSelect
                    thisUser={thisUser}
                    presetTopics={presetTopics}
                    isMulti={true} 
                    defaultMenuIsOpen={false}
                    menuIsOpen={topicsMenuOpen}
                    setMenuIsOpen={setTopicsMenuOpen}
                    tagsTable={topicsTable} 
                    callback={handleTopicSelectCallback} 
                    // tagsLevel={1} 
                    tagsLevel={currentSocialTopicsLevel}
                    target={target} 
                    placeholder={'Topics'} 
                    selectedParent={'data.talent_sector_industry?.id'}/>
                  </div>}
            </div>


            {user?.user_roles.role === 'ROOT' &&
            <>
            {/* timeless post url */}
                <div className="w-full col-span-1 xl:col-span-2">
               <p className="mx-1 my-1 text-slate-400 text-sm">
              Timeless post url
             </p>
             <div className="dark:border dark:rounded-lg dark:border-slate-600">
              <InputText 
              name='social_post_url'
              required={false}
              lightBGValue={'bg-slate-100 dark:bg-slate-700'}
              darkBGValue={'dark:bg-slate-700'}
              data={{
                type: 'text',
                id: 'social_post_title',
                onChange:(x)=>{handleChange(x)},
                label: 'Post Url',
                value: SMPostData?.social_post_url || ''
                }}
                // error={missingFields?.social_post_title ? true : false}
                />
                </div>
            </div>
            {/* allow comments */}
              <div className="w-full col-span-1 xl:col-span-2 mt-2">
             <div className="">
              <label className="flex">
               {/* {console.log('SMPostData', SMPostData.is_anonymous, SMPostData.is_timeless, SMPostData.is_commentable)} */}
              <input className="mr-1"   checked={SMPostData?.is_commentable} type="checkbox" id="is_commentable" name="is_commentable" onChange={x=>handleChange(x)}></input>
              <p>Allow others to comment</p> </label>
              {/* <InputText 
              name='social_post_url'
              required={false}
              lightBGValue={'bg-slate-100 dark:bg-slate-700'}
              darkBGValue={'dark:bg-slate-700'}
              data={{
                type: 'text',
                id: 'social_post_title',
                onChange:(x)=>{handleChange(x)},
                label: 'Post Url',
                value: SMPostData?.social_post_url || ''
                }}
                // error={missingFields?.social_post_title ? true : false}
                /> */}
                </div>
            </div>
            <div className="w-full col-span-1 xl:col-span-2 mt-2">
              <p>Visibility</p>
              <div className="p-3 space-y-2">
                <label className="flex items-center">
                  <input
                    className="mr-2"
                    type="radio"
                    name="social_post_visibility"
                    value="GLOBAL"
                    checked={SMPostData?.social_post_visibility === 'GLOBAL'}
                    onChange={x=>handleChange(x)}
                  />
                  <p>Global</p>
                </label>

                <label className="flex items-center">
                  <input
                    className="mr-2"
                    type="radio"
                    name="social_post_visibility"
                    value="PROFILE"
                    checked={SMPostData?.social_post_visibility === 'PROFILE'}
                    onChange={x=>handleChange(x)}
                  />
                  <p>Only on your profile</p>
                </label>
              </div>
            </div>
            </>
            }
      </div>

              <MarkdownEditor 
                onKeyDown={handleKeyDown}
                isTimelessPost={SMPostData.is_timeless}
                  textAreaRows ={textAreaRows}
                textAreaOnChange={handleChange}
                // textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
                textAreaName={'social_post_body'}
                textAreaId={'social_post_body'}
                callback={(x)=>{handleChange(x)}} 
                showPreview={previewPostOpen} 
                textAreaRef={textAreaRef1} 
                textAreaValue={SMPostData.social_post_body} 
                textAreaPlaceholder={'Share something timeless..'}
              />

                

    </div>

  :

  <div className="relative">
    <textarea
      // rows={parentPost ? 1 : 3}
      onKeyDown={handleKeyDown}
      ref={ref}
      rows ={textAreaRows}
      placeholder={placeholder || parentPost ? 'Write a comment…' : 'Share something…'}
      style={{ resize: 'none' }}
      className={`
        no-scrollbar 
        w-full
        p-4
        pt-12
        pb-14
        text-base
        font-inter
        ${parentPost ? 'rounded' : 'rounded-xl'}
        bg-slate-100
        text-black
        dark:bg-slate-800
        dark:text-white
        dark:border
        dark:border-slate-700
        focus:outline-none
        dark:placeholder-slate-400
      `}
      name="social_post_body"
      id="social_post_body"
      onChange={handleChange}
      value={SMPostData.social_post_body}
    />
        {/* <MentionTextArea  onChange={(x)=>handleChange(x)} value={SMPostData.social_post_body}/> */}
    </div>
      }
    </div>

  }



  {/* top + bottom bar */}
  <div className={``}>
    {/* <div className={`bg-slate-100 dark:bg-slate-800 absolute bottom-0 left-0 w-full border-b border-l border-r border-slate-100 dark:border-slate-700 h-14 ${parentPost ? 'rounded-b' : 'rounded-b-xl'}`}></div> */}


{/* bottom bar */}
<div 
className={`absolute ${SMPostData.is_timeless ? 'bottom-[8px] right-[15px]' : 'bottom-[12px] right-[6px]'} h-10 w-48 bg-slate-100 dark:bg-slate-800 rounded-lg border dark:border-slate-700`}
// className={`bg-slate-100 dark:bg-slate-800 absolute bottom-0 left-0 w-full border-t border-l border-r border-slate-100 dark:border-slate-700 h-12`}
>
  
<div className="">
  {/* no longer used since tiptap */}
     {/* {SMPostData.is_timeless && 
      <PreviewPostButton disabled={parentPost} isActive={previewPostOpen} toolTipCaption={'Preview Post'} loading={loading} 
   onClick={() => {
    // setPreviewPostOpen(false)
    setPreviewPostOpen(!previewPostOpen)}
  } caption={'Post'}/>} */}



  

   <TimelessPostButton 
   disabled={parentPost || timelessPostButtonDisabled} 
   isTimeless={SMPostData.is_timeless} 
   toolTipCaption={'Timeless post'} 
   loading={loading} 
   onClick={() => {
    // let newIsTimeless;
    setSMPostData(prev => {
      const newIsTimeless = !prev.is_timeless;
      setCharLimit(newIsTimeless ? 20000 : 1000);
      
      // Open preview automatically when becoming timeless
      setPreviewPostOpen(newIsTimeless);
      
      // Reset selected topics
      setSelectedLevel1Topics([])
      setSelectedLevel2Topics([])
      setSelectedLevel3Topics([])
      setSelectedLevel4Topics([])

      return {
        ...prev,
        is_timeless: newIsTimeless
      };
    });

    // params.set('switchToTimeless', String(newIsTimeless))
    // params.delete(newIsTimeless === false ? "switchToTimeless" : '');
    // router.replace(`?${params.toString()}`);

  }
  } caption={'Post'}/>


    <AnonymousButton disabled={actor?.organization_uuid || anonymousModeButtonDisabled} toolTipCaption={actor?.organization_uuid ? 'Anonymous mode' : 'Anonymous mode'} loading={loading} isAnonymous={SMPostData.is_anonymous} onClick={() =>
    setSMPostData(prev => ({
      ...prev,
      is_anonymous: !prev.is_anonymous
    }))
  } caption={'Post'}/>


<MediaAttachmentButton isActive={fileUploadDialogOpen === true} toolTipCaption={parentPost ? 'Attach image (available soon)' : 'Attach image'} disabled={parentPost ? true : mediaAttachmentButtonDisabled ? true : false} loading={loading} onClick={()=>setFileUploadDialogOpen(!fileUploadDialogOpen)} caption={'Post'}/>

  
    <FloppyDiskButton disabled={isComment} key={'floppydiskbutton'} loading={loading} onClick={()=>handleSubmit('DRAFT')} caption={'Draft'} toolTipCaption={'Save draft'}/>

  <PlaneButton key={'planebutton'} loading={loading} onClick={()=>handleSubmit('ACTIVE')} caption={'Post'}/>
</div>
</div>



{/* top bar  */}
<div className={`bg-slate-100 dark:bg-slate-800 absolute top-0 left-0 w-full border-t border-l border-r border-slate-100 dark:border-slate-700 h-12 ${parentPost ? 'rounded' : 'rounded-xl'}`}>
    <div className="absolute top-2 right-6 flex items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition">
      <p className={`text-xs mb-2 text-right ${charLimitError && 'text-red-500'} text-slate-300`}>{charCount}/{charLimit}</p>
    </div>

{/* Post as Organization */}
   {/* {thisUser?.user_affiliations_organizations_owned &&  */}
      {SMPostData.is_timeless && !target && <div className="absolute -top-1 -left-2 flex flex-col items-center justify-center h-5 w-5 rounded-full text-slate-500 transition rounded-full bg-slate-200 dark:bg-slate-800 border dark:border-slate-700 cursor-pointer hover:opacity-75" 
      onClick={()=>{
        setSMPostData({...SMPostData, is_timeless: false}); 
        setCharLimit(1000)
        // params.set('switchToTimeless', String(false))
        // params.delete("switchToTimeless");
        // router.replace(`?${params.toString()}`);
        }}><i className="fa fa-solid fa-xmark text-xs"></i></div>}
      {thisUser && 
        <div className="absolute top-2 left-1 flex flex-col items-center justify-center h-7 w-18 rounded-full text-slate-500 transition">
        <ActorSelectionDropdown parentPost={parentPost} parentComponent={parentPost && 'THREAD'} thisUser={thisUser} callback={cb => setActor(cb.actor || thisUser)}/>

        {/* {actorSelectionDialogOpen === true && <div className="absolute top-2 left-6 flex flex-col items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition">
          {thisUser.user_affiliations_organizations_owned.map(org => {
            return <div className="text-xs" key={org.organization_uuid}>{org.organization_name}</div>
          })}

          </div>} */}
          </div>
      }

      
</div>



   {/* {thisUser.user_affiliations_organizations_owned && 
   <div>
   <div onClick={()=>setActorSelectionDialogOpen(true)} className="absolute top-2 left-6 flex flex-col items-center justify-center h-9 w-12 rounded-full text-slate-500 hover:text-teal-400  transition text-xs">Post as</div>
   {actorSelectionDialogOpen === true && <div className="absolute top-2 left-6 flex flex-col items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition">
    {thisUser.user_affiliations_organizations_owned.map(org => {
      return <div className="text-xs" key={org.organization_uuid}>{org.organization_name}</div>
    })}

    </div>}
    </div>
    } */}

    </div>

   
    
</div>


{SMPostData.is_timeless === false && <div className={`z-10 ${SMPostData.is_timeless && `mt-1 ${selectedLevel1Topics?.length > 0 && 'pb-4'} dark:bg-slate-700 rounded-lg transition-all duration-150 relative left-1/2 -translate-x-1/2 xl:w-[calc(100vw-20rem)] ${parentPost ? 'max-w-7xl' : 'max-w-5xl'}`}`}>

  {(!parentPost || target) && showTopics===true && SMPostData.social_post_body?.length > 1 && <div className={`${SMPostData.is_timeless && ''}`}>
    {/* helper text to identify topics */}
                      {topicLevelsTooltipVisible === true && 
                  <div className="mx-1 my-1 text-slate-400 text-sm flex justify-between items-center gap-8">
                    {/* {currentSocialTopicsLevel > 1 ? 
                      <RoundButton 
                        caption={
                          currentSocialTopicsLevel === 2 ? 'Area' :
                          currentSocialTopicsLevel === 3 ? 'Stage' :
                          currentSocialTopicsLevel === 4 ? 'Focus' : 
                          ''
                        } 
                        onClick={()=>setCurrentSocialTopicsLevel(prev => prev - 1)}
                      /> 
                      : <div></div>
                    } */}
                    <div className="">
                    <p className="">
                    {currentSocialTopicsLevel === 1  ? 
                      <>What <strong>area</strong> is this post in? (select 1)</> : 
                    currentSocialTopicsLevel === 2  ?
                      <>Where <strong>within {selectedLevel1Topics?.[0]?.topic_name_en}</strong>? (<strong>the stage</strong>, select up to 2, or <span className="underline cursor-pointer" onClick={()=>setCurrentSocialTopicsLevel(3)}>skip the second</span>)</> :
                    currentSocialTopicsLevel === 3  ? 
                      <>What is it about? (<strong>the focus</strong>, select 1, or <span className="underline cursor-pointer" onClick={()=>setCurrentSocialTopicsLevel(4)}>skip the focus topic</span>)</> : 
                    currentSocialTopicsLevel === 4  ? 
                      <>What kind of post is it? (<strong>the intent</strong>, select 1)</>
                      : currentSocialTopicsLevel + ' ' + 'Done!'
                      }
                  </p>
                  </div>
                  {/* {currentSocialTopicsLevel < 4 ? <RoundButton 
                    onClick={()=>setCurrentSocialTopicsLevel(prev => prev + 1)} 
                    caption={
                      currentSocialTopicsLevel === 1 ? 'Stage' :
                        currentSocialTopicsLevel === 2 ? 'Focus' :
                        currentSocialTopicsLevel === 3 ? 'Intent' : 
                        ''
                    } 
                    iconClassName={'fa-solid fa-arrow-right-long'} 
                    order={'iconAfterCaption'}
                  />
                    :
                    <div></div>
                  } */}
                  </div>}

    <SocialTopicsAssociationSelect
      // onSkip={() => {
      //   setTopicsMenuOpen(false);
      //   setCurrentSocialTopicsLevel(prev => Math.min(prev + 1, 4));
      // }}
    defaultMenuIsOpen={false}
 menuIsOpen={topicsMenuOpen}
  setMenuIsOpen={setTopicsMenuOpen}
      thisUser={thisUser}
      presetTopics={presetTopics}
      isMulti={true} 
      tagsTable={topicsTable} 
      callback={handleTopicSelectCallback} 
      //  tagsLevel={1} refactoring to conditional tagslevels
      tagsLevel={
        currentSocialTopicsLevel
      }
     target={target} 
     placeholder={'Topics'}
     selectedParent={'data.talent_sector_industry?.id'}/>
    </div>}



    {selectedLevel1Topics?.length > 0 && 
    selectedLevel1Topics.map(topic => topic.topic_description?.en &&
    <div key={topic.uuid}
    className={`px-4 ${SMPostData.is_timeless === true && "mx-10"} py-2 ${'mt-2'}
rounded-lg
border border-teal-200 dark:border-teal-500
bg-teal-50
dark:bg-transparent
text-teal-800`}>
      <p className="text-xs"><strong>{topic.topic_name_en} topic subjects:</strong> {topic.topic_description?.en?.split('\n').join(', ')}</p>
    </div>)}

        {selectedLevel2Topics?.length > 0 && 
    selectedLevel2Topics.map(topic => topic.topic_description?.en &&
    <div key={topic.uuid}
    className={`px-4 ${SMPostData.is_timeless === true && "mx-10"} py-2 ${'mt-2'}
rounded-lg
border border-teal-200 dark:border-teal-500
bg-teal-50
dark:bg-transparent
text-teal-800`}>
      <p className="text-xs"><strong>{topic.topic_name_en} topic subjects:</strong> {topic.topic_description?.en?.split('\n').join(', ')}</p>
    </div>)}

</div>}

    {!parentPost && <div className="w-full border-b mt-3 dark:border-slate-700"/>}
    
    
{/* file preview */}
{/* <div className={`${filePreview ? 'opacity-100' : 'opacity-0'} bg-slate-100 dark:bg-slate-900 w-full p-4 rounded-xl`}>
  <div className="-m-4 h-10 w-10 bg-slate-500 rounded-full flex items-center justify-center text-xs z-50">x</div>
<img 
  src={filePreview} 
  className="max-h-32 max-w-xs object-cover rounded z-0" 
  alt="" 
/>
</div> */}


{filePreview && <div className={`bg-slate-100 dark:bg-slate-900 w-full p-4 rounded-xl`}>
  <div className="relative inline-block">
    <img
      src={filePreview}
      className="max-h-32 max-w-xs object-cover rounded"
      alt=""
    />

    <button
      className="absolute -top-2 -left-2 h-5 w-5 bg-slate-400 dark:bg-slate-500 text-white rounded-full flex items-center justify-center text-xs z-0 hover:bg-slate-900 duration-300 text-light"
      onClick={() => {setFilePreview(null); setFileData(null)}}
    >
       <i className="fas fa-times"></i>
      {/* × */}
    </button>
  </div>
</div>}

</div>


{/* <div
  className={`bg-slate-50 dark:bg-slate-950 opacity-85 fixed top-0 left-1/2 w-full transform -translate-x-1/2 transition-all duration-300 h-full flex ${parentPost ? 'items-center' : 'items-end'} justify-center
    ${fileUploadDialogOpen 
      ? 'translate-y-0 opacity-100 pointer-events-auto' 
      : '-translate-y-full opacity-0 pointer-events-none'}`
  }
>
  <FileUploadDragAndDrop
    caption={'Drag and drop an image here or click to browse'}
    callback={cb => handleFileUpload(cb)}
    lang={'en'}
    // fileName={'testFileName'}
    fileName={fileData?.file_name}
  />
</div> */}


{/* <div className={`${fileUploadDialogOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-100'} transition-all duration-300`}>
  <FileUploadDragAndDrop callback={()=>handleFileUpload()} user={user} lang={'en'} fileName={'testFileName'}/>
</div> */}

     {/* <MentionTextArea  onChange={(x)=>handleChange(x)} value={SMPostData.social_post_body}/> */}

      {/* <p className={`text-xs mb-2 text-right ${charLimitError && 'text-red-500'} text-slate-300`}>{charCount}/{CHAR_LIMIT}</p> */}
      {/* <TealButton loading={loading} onClick={()=>handleSubmit()} caption={'Post'}/> */}
      </>
  )
}

export default NewSocialPostCard